import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { ENDPOINTS } from './ENDPOINTS';
import { getPaginationHeader } from './utils/get-pagination-headers';
import { Clinic } from '../interfaces/clinic.interface';

@Injectable({
  providedIn: 'root',
})
export class ClinicService {
  private http = inject(HttpClient);
  getAll(params = { page: 1 }) {
    return this.http
      .get<{ count: number; data: Clinic[] }>(ENDPOINTS.clinics.all, {
        observe: 'response',
        params,
      })
      .pipe(
        map((response) =>
          getPaginationHeader<Clinic>({
            ...response,
            body: response.body?.data,
          })
        )
      );
  }

  getDetails(clinicId: string) {
    return this.http.get<Clinic>(ENDPOINTS.clinics.details(clinicId));
  }
  delete(clinicIds: string[]) {
    return this.http.delete(ENDPOINTS.clinics.delete, {
      body: {
        clinicIds,
      },
    });
  }
  createClinic(
    ownerId: string,
    body: Partial<Clinic> | FormData,
    token?: string
  ) {
    const isBodyFormdata = body instanceof FormData;
    const fd = isBodyFormdata ? body : new FormData();
    if (!isBodyFormdata) {
      Object.entries(body).forEach(([key, value]) => {
        if (value instanceof File) {
          fd.append(key, value);
        } else {
          fd.append(key, JSON.stringify(value));
        }
      });
    }
    const options = {
      headers: {} as any,
    };
    if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
    }
    return this.http.post<Clinic>(
      ENDPOINTS.clinics.create(ownerId),
      fd,
      options
    );
  }
  editClinic(clinicId: string, body: Partial<Clinic> | FormData) {
    const isBodyFormdata = body instanceof FormData;
    const fd = isBodyFormdata ? body : new FormData();
    if (!isBodyFormdata) {
      Object.entries(body).forEach(([key, value]) => {
        if (value instanceof File) {
          fd.append(key, value);
        } else {
          fd.append(key, JSON.stringify(value));
        }
      });
    }
    return this.http.put<Clinic>(ENDPOINTS.clinics.edit(clinicId), fd);
  }
}
